import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Band } from '@antv/scale';
import { deepMix } from '@antv/util';
import { column, columnOf } from './utils/helper';
import { domainOf } from './utils/order';
export function rangeOf(value, scaleOptions, padding) {
  if (value === null) return [-0.5, 0.5];
  var domain = domainOf(value, scaleOptions);
  var scale = new Band({
    domain: domain,
    range: [0, 1],
    padding: padding
  });
  var step = scale.getBandWidth();
  return [-step / 2, step / 2];
}
export function interpolate(t, a, b) {
  return a * (1 - t) + b * t;
}
/**
 * The jitter transform produce dx and dy channels for marks (especially for point)
 * with ordinal x and y dimension, say to make them jitter in their own space.
 */
export var Jitter = function Jitter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$padding = options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding,
    _options$paddingX = options.paddingX,
    paddingX = _options$paddingX === void 0 ? padding : _options$paddingX,
    _options$paddingY = options.paddingY,
    paddingY = _options$paddingY === void 0 ? padding : _options$paddingY,
    _options$random = options.random,
    random = _options$random === void 0 ? Math.random : _options$random;
  return function (I, mark) {
    var encode = mark.encode,
      scale = mark.scale;
    var scaleX = scale.x,
      scaleY = scale.y;
    var _columnOf = columnOf(encode, 'x'),
      _columnOf2 = _slicedToArray(_columnOf, 1),
      X = _columnOf2[0];
    var _columnOf3 = columnOf(encode, 'y'),
      _columnOf4 = _slicedToArray(_columnOf3, 1),
      Y = _columnOf4[0];
    var rangeX = rangeOf(X, scaleX, paddingX);
    var rangeY = rangeOf(Y, scaleY, paddingY);
    var DY = I.map(function () {
      return interpolate.apply(void 0, [random()].concat(_toConsumableArray(rangeY)));
    });
    var DX = I.map(function () {
      return interpolate.apply(void 0, [random()].concat(_toConsumableArray(rangeX)));
    });
    return [I, deepMix({
      scale: {
        x: {
          padding: 0.5
        },
        y: {
          padding: 0.5
        }
      }
    }, mark, {
      encode: {
        dy: column(DY),
        dx: column(DX)
      }
    })];
  };
};
Jitter.props = {};